/*
 * @Author: sun fei
 * @Date: 2021-11-18 16:30:12
 * @LastEditTime: 2021-11-18 19:17:12
 * @LastEditors: sun fei
 * @Description: 提示
 */

import Vue from 'vue';
let v = new Vue();

const requestTip = {
	// 网络异常提示
	showNetworkError(err) {
		console.error('err-->>', err);
		if (String(err).includes('timeout')) {
			v.$message({
				message: '请求超时，请稍后再试',
				type: 'error',
				duration: 1500,
			});
		} else {
			v.$message({
				message: '网络异常，请稍后再试',
				type: 'error',
				duration: 1500,
			});
		}
	},
	// 请求失败提示
	showReqError(res, msg) {
		console.error('err-->>', res);
		v.$message({
			message: msg,
			type: 'error',
			duration: 1500,
		});
	},
	// 成功提示
	showSuccess(msg) {
		v.$message({
			message: msg,
			type: 'success',
			duration: 1500,
		});
	},
};
export default requestTip;
